import React from 'react'

const BillingBlackIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.33464 1.67188H16.668C17.1263 1.67188 17.5188 1.83521 17.8455 2.16188C18.1721 2.48854 18.3352 2.88076 18.3346 3.33854V12.5052C18.3346 12.9635 18.1716 13.356 17.8455 13.6827C17.5194 14.0094 17.1269 14.1724 16.668 14.1719H13.3346V18.3385L10.0013 16.6719L6.66797 18.3385V14.1719H3.33464C2.8763 14.1719 2.48408 14.0088 2.15797 13.6827C1.83186 13.3566 1.66852 12.9641 1.66797 12.5052V3.33854C1.66797 2.88021 1.8313 2.48799 2.15797 2.16188C2.48464 1.83576 2.87686 1.67243 3.33464 1.67188ZM3.33464 10.8385H16.668V8.33854H3.33464V10.8385Z" fill="#454242"/>
    </svg>
  )
}

export default BillingBlackIcon